const initialState = false;

export const startLoading = () => true;

export const endLoading = () => false;

export default initialState;
